




import ChatBot from '../components/ChatBot.vue'
import { Vue, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import { Debounce } from '@/modules/core/utils/decorators'
import { DialogService } from '@/modules/chatbot/services/dialog.service'

@Component({
  components: { ChatBot }
})
export default class ChatBotView extends Vue {

}
